__turbopack_context__.v({
  "arrowBtn": "gWVgvW_arrowBtn",
  "arrowBtnDisabled": "gWVgvW_arrowBtnDisabled",
  "arrowsWrap": "gWVgvW_arrowsWrap",
  "carousel": "gWVgvW_carousel",
  "carouselContainer": "gWVgvW_carouselContainer",
  "carouselItem": "gWVgvW_carouselItem",
  "itemsContainer": "gWVgvW_itemsContainer",
  "mobile": "gWVgvW_mobile",
});
